import {Component, OnInit} from "@angular/core";
import {New} from "./new";
import {NewService} from "./new.service";
import {Router} from "@angular/router";
declare var jquery:any; // 這邊用 var 
declare let $:any; // 當然 let 也可以
@Component({
  template:`    
    <div class="big-about">
       
        <div class="middle-box"><br>
        <h2>最新消息</h2><br>
        <div class="line-about"></div><br>
        <p>關於本店近況及商品的最新消息皆會在此不定期發佈！！！
        </p>
        </div></div>
        <div class="container">
        <div class="title-clothes">
        <div class="title-clothes-line"></div>最新消息<div class="title-clothes-line2"></div>
        </div>
        
        <div class="categoryBtn">
        <button class="newBtn2" (click)="gotoNew()">全部</button>

        <button class="newBtn2" (click)="gotoNew2()">活動</button>
        <button class="newBtn2" (click)="gotoNew3()">評測</button>
        <button class="newBtn2" (click)="gotoNew4()">新品</button>
        <button class="newBtn2" (click)="gotoNew5()">重要</button>
        <button class="newBtn2" (click)="gotoNew6()">情報</button>
        </div>
        <div class="cool"><button class="changefont" (click)="gotoDetail219()">2020-07-23<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY" 運動毛巾【日本今治認證】登場！</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail218()">2020-07-19<span class="category">新品</span><p class="cool2"></p>"MIZUNO" Sumikko Gurashi 限量聯名款訓練T恤</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail217()">2020-07-18<span class="category">新品</span><p class="cool2"></p>"MIZUNO" 美津濃東京奧運限定鞋款 火熱到貨～！</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail216()">2020-07-14<span class="category">新品</span><p class="cool2"></p>"VICTAS" LIAM PITCHFORD 全新底板正式上市🎊</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail215()">2020-07-10<span class="category">新品</span><p class="cool2"></p>"XIOM"36.5 ALX 底板 開賣囉～</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail214()">2020-07-03<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY"「林昀儒」桌球拍 新上市!</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail213()">2020-06-30<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY"最新款黏性膠皮AIBISS 發燒到貨</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail212()">2020-06-23<span class="category">新品</span><p class="cool2"></p>"Mizuno" 美津濃短袖運動T恤【台灣限定】</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail211()">2020-06-20<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY"【AIBISS】全新黏性膠皮的新選擇</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail210()">2020-06-18<span class="category">新品</span><p class="cool2"></p>"STIGA" 時尚潮運動裝備袋</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail209()">2020-06-10<span class="category">新品</span><p class="cool2"></p>"Mizuno" 2020 新款桌球鞋(限定色)到貨</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail208()">2020-06-02<span class="category">新品</span><p class="cool2"></p>"STIGA" 碳素紀元Leagcy Carbon國際版</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail207()">2020-05-19<span class="category">新品</span><p class="cool2"></p>【DONICx哆啦A夢】桌球T恤聯名C款</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail206()">2020-05-10<span class="category">新品</span><p class="cool2"></p>"ARIEX" 艾銳斯Trigram SUPER ZLC(台灣製)</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail205()">2020-05-07<span class="category">新品</span><p class="cool2"></p>"Nittaku" 100 週年慶限量飛行夾克開賣</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail204()">2020-05-04<span class="category">新品</span><p class="cool2"></p>"Mizuno" WAVE KAISERBURG 6 新品熱賣中！</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail202()">2020-03-27<span class="category">新品</span><p class="cool2"></p>"MIZUNO"2020 美津濃新款運動服到貨</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail201()">2020-03-19<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY"2020新品 3/19提前到貨！</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail198()">2020-03-05<span class="category">新品</span><p class="cool2"></p>"STIGA"樊振東個人專屬底板-樊系橙標 即將上市</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail197()">2020-02-21<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY"『超級張本ZLC』即將上市</button><br><br></div> 
      
        <button class="newBtn" (click)="show1()" *ngIf="more1 == false">更多消息</button>

        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail185()">2019-11-26<span class="category">新品</span><p class="cool2"></p>"Mizuno" 不敗的經典設計/基本款桌球鞋</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail184()">2019-11-22<span class="category">新品</span><p class="cool2"></p>"Mizuno" 2020 桌球運動鞋 公司進口限定色上市 💫</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail182()">2019-11-11<span class="category">新品</span><p class="cool2"></p>"STIGA" DNA系列膠皮 "德國意志"，火熱開賣中!!!</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail181()">2019-11-01<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY"新品到貨～林高遠ALC、D64、D80</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail178()">2019-10-25<span class="category">新品</span><p class="cool2"></p>"STIGA" DNA PRO 平面膠皮，即將到貨！</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail177()">2019-10-13<span class="category">新品</span><p class="cool2"></p>流行時尚的"XIOM"軍團秘密武器再次發佈</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail176()">2019-10-12<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY" D64、D80平面膠皮 即將震撼上市</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail174()">2019-09-06<span class="category">新品</span><p class="cool2"></p>BUTTERFLY 2019 秋冬新製品登場！🏓🏓🏓</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail170()">2019-07-26<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY"最新款 LOGO 字樣蝴蝶拍套上市</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail167()">2019-07-12<span class="category">新品</span><p class="cool2"></p>"STIGA"國際級進口專業比賽級球桌火熱開賣</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail166()">2019-07-11<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY"LEZOLINE-JL II兒童鞋款 抵台上市</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail163()">2019-06-12<span class="category">新品</span><p class="cool2"></p>STIGA瑞典原裝進口桌球運動服飾👕 亮相 ✨💯✨</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail160()">2019-05-29<span class="category">新品</span><p class="cool2"></p>2019夏季美津濃(Mizuno)桌球器材重裝出擊 ‼️‼️‼️</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail158()">2019-05-20<span class="category">新品</span><p class="cool2"></p>🇸🇪 STIGA 75周年底板-特製Clipper紀念板到貨 🇸🇪 </button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail153()">2019-05-03<span class="category">新品</span><p class="cool2"></p>"DHS紅雙喜"狂飆龍5X、世界巡迴賽乒乓用球 到貨</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail151()">2019-04-30<span class="category">新品</span><p class="cool2"></p>2019 最具話題的"XIOM"時尚拍套總整理🎊🎉</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail148()">2019-04-20<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY" 2019春季商品原裝空運 新貨到～</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail145()">2019-04-04<span class="category">新品</span><p class="cool2"></p>"DHS紅雙喜" 新版 狂飆龍5X(馬龍用)上市</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail144()">2019-04-02<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY" DIGNICS 05🆕 上市開賣</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail142()">2019-03-21<span class="category">新品</span><p class="cool2"></p>"Nittaku" 2019全系列服飾 即將上市</button><br><br></div> 

        <button class="newBtn" (click)="show2()" *ngIf="more1==true && more2 == false">更多消息</button>

        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail141()">2019-03-16<span class="category">新品</span><p class="cool2"></p>"STIGA" 2019 春夏桌球運動圓領 T-SHIRT</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail140()">2019-03-13<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY"DIGNICS 05 最新款膠皮 即將到貨</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail138()">2019-02-23<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY"日本原裝進口抗菌除臭運動襪到貨</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail136()">2019-02-21<span class="category">新品</span><p class="cool2"></p>"STIGA"新品系列 塩野真人共同開發🥇🥇🥇</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail135()">2019-02-16<span class="category">新品</span><p class="cool2"></p>XIOM底板 冰淇淋"ICE CREAM" 火熱到貨❗</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail134()">2019-02-15<span class="category">新品</span><p class="cool2"></p>許昕藍標限量(and黑標)底板限量到貨，欲購從速~~~ </button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail129()">2019-01-29<span class="category">新品</span><p class="cool2"></p>『莊智淵簽約15周年全球限量紀念拍』 首批到貨～</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail128()">2019-01-29<span class="category">新品</span><p class="cool2"></p>德國桌球大廠 DONIC 新款T-SHIRT 開始販售</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail127()">2019-01-24<span class="category">新品</span><p class="cool2"></p>STIGA 2019 春夏桌球運動圓領 T-Shirt 開始販售</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail125()">2019-01-12<span class="category">新品</span><p class="cool2"></p>好消息!!! STIGA GENESIS II 📣 2019上市 📣</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail124()">2019-01-10<span class="category">新品</span><p class="cool2"></p>2019 "Mizuno"新款抗紫外線短袖T恤</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail122()">2019-01-07<span class="category">新品</span><p class="cool2"></p>➡️ 壓倒性的進化 Dignics 05 ⬅️</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail118()">2018-12-20<span class="category">新品</span><p class="cool2"></p>"STIGA" SYMMETRY 新貨到👀👀👀</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail113()">2018-12-02<span class="category">新品</span><p class="cool2"></p>2018友誼729 全新款藍芳碳纖維桌球底板</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail112()">2018-11-30<span class="category">新品</span><p class="cool2"></p>"Nittaku"日本製三星新塑料橘色比賽球</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail111()">2018-11-26<span class="category">新品</span><p class="cool2"></p>"MIZUNO" 2019春夏新款桌球鞋提前上市 獨步全台</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail109()">2018-11-21<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY" 莊智淵全球限量紀念拍 預購開跑!</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail108()">2018-11-20<span class="category">新品</span><p class="cool2"></p>"MIZUNO" 2018秋冬款運動童鞋 💫 正品上市 💫 </button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail105()">2018-11-03<span class="category">新品</span><p class="cool2"></p>"STGIA" Dynasty Carbon限量到貨開放預約</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail104()">2018-11-01<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY" Tenergy 05 Hard 🔥火熱到貨🔥</button><br><br></div> 

        <button class="newBtn" (click)="show3()" *ngIf="more2==true && more3 == false">更多消息</button>

        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail103()">2018-10-30<span class="category">新品</span><p class="cool2"></p>NEW 2018 "DONIC"秋冬T-SHIRT 上市</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail102()">2018-10-26<span class="category">新品</span><p class="cool2"></p>2018新款蝴蝶牌 TIMO BOLL 系列 即將到貨！</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail99()">2018-10-09<span class="category">新品</span><p class="cool2"></p>"STIGA" 秋冬T-Shirt 現正販售中</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail91()">2018-09-08<span class="category">新品</span><p class="cool2"></p>全新款"MIZUNO"男女運動排汗衫</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail87()">2018-08-31<span class="category">新品</span><p class="cool2"></p>迷你乒乓小球桌，【波爾桌球用品專賣店】買得到</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail83()">2018-08-17<span class="category">新品</span><p class="cool2"></p>"Mizuno" 台灣款配色運動鞋特價供應 💪💪💪</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail82()">2018-08-10<span class="category">新品</span><p class="cool2"></p>STIGA“杜鵑花”系列全面盛開怒放【新貨入荷】</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail79()">2018-07-28<span class="category">新品</span><p class="cool2"></p>DONIC 2018 夏季圓領T恤上市💓💓💓</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail77()">2018-07-23<span class="category">新品</span><p class="cool2"></p>XIOM VEGA TOUR(金V)內能膠皮到貨📣📢</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail79()">2018-07-28<span class="category">新品</span><p class="cool2"></p>DONIC 2018 夏季圓領T恤上市💓💓💓</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail77()">2018-07-23<span class="category">新品</span><p class="cool2"></p>XIOM VEGA TOUR(金V)內能膠皮到貨📣📢</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail75()">2018-07-19<span class="category">新品</span><p class="cool2"></p>BUTTERFLY蝴蝶牌2018原創限量 T 預購開跑 ❤️💕</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail77()">2018-07-23<span class="category">新品</span><p class="cool2"></p>XIOM VEGA TOUR(金V)內能膠皮到貨📣📢</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail75()">2018-07-19<span class="category">新品</span><p class="cool2"></p>BUTTERFLY蝴蝶牌2018原創限量 T 預購開跑 ❤️💕</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail73()">2018-07-14<span class="category">新品</span><p class="cool2"></p>2018 "STIGA" 絕殺武器紅豆木底板三款到貨</button><br><br></div>
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail72()">2018-07-12<span class="category">新品</span><p class="cool2"></p>"美津濃" MIZUNO桌球膠皮 Q4 台灣首發上市</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail71()">2018-07-10<span class="category">新品</span><p class="cool2"></p>"美津濃"WAVE MEDAL 5 新款桌球鞋，搶先登場！</button><br><br></div>
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail70()">2018-07-02<span class="category">新品</span><p class="cool2"></p>"STIGA" 2018 NOSTALGIC 傳奇系列–即將到貨</button><br><br></div>
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail68()">2018-06-17<span class="category">新品</span><p class="cool2"></p>"美津濃"桌球膠皮 2018 大進擊，全新Q4實拍</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail67()">2018-06-13<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY" 2018夏季鞋款 與日本同步上市</button><br><br></div> 

        <button class="newBtn" (click)="show4()" *ngIf="more3==true && more4 == false">更多消息</button>

        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail66()">2018-06-08<span class="category">新品</span><p class="cool2"></p>"美津濃,Nittaku,DONIC"新款運動短褲🔥火熱🔥上市</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail65()">2018-05-23<span class="category">新品</span><p class="cool2"></p>“美津濃"2018夏季最新款桌球鞋台灣上架囉～</button><br><br></div>
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail67()">2018-06-13<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY" 2018夏季鞋款 與日本同步上市</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail66()">2018-06-08<span class="category">新品</span><p class="cool2"></p>"美津濃,Nittaku,DONIC"新款運動短褲🔥火熱🔥上市</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail65()">2018-05-23<span class="category">新品</span><p class="cool2"></p>“美津濃"2018夏季最新款桌球鞋台灣上架囉～</button><br><br></div>
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail63()">2018-05-18<span class="category">新品</span><p class="cool2"></p>只送不賣DHS雙色乒乓球(至門市FB打卡 即贈2顆)</button><br><br></div>
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail57()">2018-04-26<span class="category">新品</span><p class="cool2"></p>2018 日本“BUTTERFLY” 春夏季款商品到貨！</button><br><br></div>
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail55()">2018-04-19<span class="category">新品</span><p class="cool2"></p>"STIGA" LINER II 紅白 專業桌球鞋🌟 新貨到港 🌟</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail53()">2018-04-15<span class="category">新品</span><p class="cool2"></p>【BTY 新製品介紹】2018 Spring Summer 春夏服裝</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail49()">2018-04-05<span class="category">新品</span><p class="cool2"></p>日本"Mizuno"桌球鞋全系列到貨～欲購從速!!!</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail48()">2018-04-02<span class="category">新品</span><p class="cool2"></p>日本"Nittaku"2018年台灣製台版服飾隆重上市</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail44()">2018-03-17<span class="category">新品</span><p class="cool2"></p>美津濃(Mizuno) 桌球用品火熱到貨!!!</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail41()">2018-03-09<span class="category">新品</span><p class="cool2"></p>🎉"STIGA" 透氣排汗上衣-新上市🎉</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail36()">2018-02-07<span class="category">新品</span><p class="cool2"></p>“BUTTERFLY”A40+ 3星比賽級塑料球上市</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail41()">2018-03-09<span class="category">新品</span><p class="cool2"></p>🎉"STIGA" 透氣排汗上衣-新上市🎉</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail36()">2018-02-07<span class="category">新品</span><p class="cool2"></p>“BUTTERFLY”A40+ 3星比賽級塑料球上市</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail31()">2017-12-23<span class="category">新品</span><p class="cool2"></p>XIOM 最新FEEL系列底板在台灣上市囉～～</button><br><br></div>
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail30()">2017-12-21<span class="category">新品</span><p class="cool2"></p>XIOM OMEGA VII PRO 專業桌球膠皮到貨啦～</button><br><br></div>
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail29()">2017-12-19<span class="category">新品</span><p class="cool2"></p>Ｎittaku S-Series系列底版(德國製)</button><br><br></div>
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail25()">2017-12-02<span class="category">新品</span><p class="cool2"></p>燒騰騰～『TIBHAR』專業兒童桌球鞋</button><br><br></div>

        <button class="newBtn" (click)="show5()" *ngIf="more4==true && more5 == false">更多消息</button>

        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail24()">2017-11-25<span class="category">新品</span><p class="cool2"></p>『TIBHAR』新款運動後背包</button><br><br></div> 
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail22()">2017-11-23<span class="category">新品</span><p class="cool2"></p>BUTTERFLY 吉村真晴『親筆簽名限量拍』</button><br><br></div>
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail18()">2017-11-09<span class="category">新品</span><p class="cool2"></p>㊣ Arctic Wood ㊣ STIGA底板 新品上市</button><br><br></div> 
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail17()">2017-11-02<span class="category">新品</span><p class="cool2"></p>BUTTERFLY CHACK SHEET 專業無機黏膠紙</button><br><br></div>
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail13()">2017-10-01<span class="category">新品</span><p class="cool2"></p>2017 秋冬新款 STIGA 無領短T排汗衣</button><br><br></div>
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail6()">2017-08-11<span class="category">新品</span><p class="cool2"></p>Palio 拍里奧新材料ABS 40+ 一星級訓練用球</button><br><br></div>  
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail5()">2017-07-05<span class="category">新品</span><p class="cool2"></p>DONIC BLUE STORM 火熱到貨！！</button><br><br></div>       
        <button (click)="topFunction()" id="return-to-top" title="Go to top">Top</button>

        </div>
      
    `,
  providers:[NewService],
  styles: [`    
    .cool button{
    float: left;
    background-color: white;
    margin-left: 30px;
    border: none;
    
    }
    
    .cool{
    width:700px;
    font-size: 18px;
    font-weight: bold;
    }
    
   
    .container{
    margin-bottom: 30px;
    }
    
    `],
  inputs:['ptitle','pcontent']

})

export class New4Component implements OnInit{
  constructor(private newservice:NewService,private router:Router){}
  new:New[];
  errorMessage:string;
  public ptitle:string;
  public pcontent:string;
  public more1 : boolean = false 
  public more2 : boolean = false
  public more3 : boolean = false
  public more4 : boolean = false
  public more5 : boolean = false
  ngOnInit(){
    this.getNews();
  }

  select2(title:string,content:string){
    this.newservice.add(title,content);
  }

  getNews(){
    this.newservice.getNews()
      .subscribe(
        products => this.new = products,
        error =>  this.errorMessage = <any>error);


  }
  gotoNew(){
    this.router.navigate(['new']);
  }
  gotoNew2(){
    this.router.navigate(['new2']);
  }
  gotoNew3(){
    this.router.navigate(['new3']);
  }
  gotoNew4(){
    this.router.navigate(['new4']);
  }
  gotoNew5(){
    this.router.navigate(['new5']);
  }
  gotoNew6(){
    this.router.navigate(['new6']);
  }
  gotoNew7(){
    this.router.navigate(['new7']);
  }
  gotoNew8(){
    this.router.navigate(['new8']);
  }
  show1(){
    this.more1 = true
  }
  show2(){
    this.more2 = true
  }
  show3(){
    this.more3 = true
  }
  show4(){
    this.more4 = true
  }
  show5(){
    this.more5 = true
  }
  gotoNewDetail(){
    this.router.navigate(['newdetail']);
  }
  gotoDetail1(){
    this.router.navigate(['detail1']);
  }
  gotoDetail2(){
    this.router.navigate(['detail2']);
  }
  gotoDetail3(){
    this.router.navigate(['detail3']);
  }
  gotoDetail4(){
    this.router.navigate(['detail4']);
  }
  gotoDetail5(){
    this.router.navigate(['detail5']);
  }
  gotoDetail6(){
    this.router.navigate(['detail6']);
  }
  gotoDetail7(){
    this.router.navigate(['detail7']);
  }
  gotoDetail8(){
    this.router.navigate(['detail8']);
  }
  gotoDetail9(){
    this.router.navigate(['detail9']);
  }
  gotoDetail10(){
    this.router.navigate(['detail10']);
  }
  gotoDetail11(){
    this.router.navigate(['detail11']);
  }
  gotoDetail12(){
    this.router.navigate(['detail12']);
  }
  gotoDetail13(){
    this.router.navigate(['detail13']);
  }
  gotoDetail14(){
    this.router.navigate(['detail14']);
  }
  gotoDetail15(){
    this.router.navigate(['detail15']);
  }
  gotoDetail16(){
    this.router.navigate(['detail16']);
  }
  gotoDetail17(){
    this.router.navigate(['detail17']);
  }
  gotoDetail18(){
    this.router.navigate(['detail18']);
  }
  gotoDetail19(){
    this.router.navigate(['detail19']);
  }
  gotoDetail20(){
    this.router.navigate(['detail20']);
  }
  gotoDetail21(){
    this.router.navigate(['detail21']);
  }
  gotoDetail22(){
    this.router.navigate(['detail22']);
  }
  gotoDetail23(){
    this.router.navigate(['detail23']);
  }
  gotoDetail24(){
    this.router.navigate(['detail24']);
  }
  gotoDetail25(){
    this.router.navigate(['detail25']);
  }
  gotoDetail26(){
    this.router.navigate(['detail26']);
  }
  gotoDetail27(){
    this.router.navigate(['detail27']);
  }
  gotoDetail28(){
    this.router.navigate(['detail28']);
  }
  gotoDetail29(){
    this.router.navigate(['detail29']);
  }
  gotoDetail30(){
    this.router.navigate(['detail30']);
  }
  gotoDetail31(){
    this.router.navigate(['detail31']);
  }
  gotoDetail32(){
    this.router.navigate(['detail32']);
  }
  gotoDetail33(){
    this.router.navigate(['detail33']);
  }
  gotoDetail34(){
    this.router.navigate(['detail34']);
  }
  gotoDetail35(){
    this.router.navigate(['detail35']);
  }
  gotoDetail36(){
    this.router.navigate(['detail36']);
  }
  gotoDetail37(){
    this.router.navigate(['detail37']);
  }
  gotoDetail38(){
    this.router.navigate(['detail38']);
  }
  gotoDetail39(){
    this.router.navigate(['detail39']);
  }
  gotoDetail40(){
    this.router.navigate(['detail40']);
  }
  gotoDetail41(){
    this.router.navigate(['detail41']);
  }
  gotoDetail42(){
    this.router.navigate(['detail42']);
  }
  gotoDetail43(){
    this.router.navigate(['detail43']);
  }
  gotoDetail44(){
    this.router.navigate(['detail44']);
  }
  gotoDetail45(){
    this.router.navigate(['detail45']);
  }
  gotoDetail46(){
    this.router.navigate(['detail46']);
  }
  gotoDetail47(){
    this.router.navigate(['detail47']);
  }
  gotoDetail48(){
    this.router.navigate(['detail48']);
  }
  gotoDetail49(){
    this.router.navigate(['detail49']);
  }
  gotoDetail50(){
    this.router.navigate(['detail50']);
  }
  gotoDetail51(){
    this.router.navigate(['detail51']);
  }
  gotoDetail52(){
    this.router.navigate(['detail52']);
  }
  gotoDetail53(){
    this.router.navigate(['detail53']);
  }
  gotoDetail54(){
    this.router.navigate(['detail54']);
  }
  gotoDetail55(){
    this.router.navigate(['detail55']);
  }
  gotoDetail56(){
    this.router.navigate(['detail56']);
  }
  gotoDetail57(){
    this.router.navigate(['detail57']);
  }
  gotoDetail58(){
    this.router.navigate(['detail58']);
  }
  gotoDetail59(){
    this.router.navigate(['detail59']);
  }
  gotoDetail60(){
    this.router.navigate(['detail60']);
  }
  gotoDetail61(){
    this.router.navigate(['detail61']);
  }
  gotoDetail62(){
    this.router.navigate(['detail62']);
  }
  gotoDetail63(){
    this.router.navigate(['detail63']);
  }
  gotoDetail64(){
    this.router.navigate(['detail64']);
  }
  gotoDetail65(){
    this.router.navigate(['detail65']);
  }
  gotoDetail66(){
    this.router.navigate(['detail66']);
  }
  gotoDetail67(){
    this.router.navigate(['detail67']);
  }
  gotoDetail68(){
    this.router.navigate(['detail68']);
  }
  gotoDetail69(){
    this.router.navigate(['detail69']);
  }
  gotoDetail70(){
    this.router.navigate(['detail70']);
  }
  gotoDetail71(){
    this.router.navigate(['detail71']);
  }
  gotoDetail72(){
    this.router.navigate(['detail72']);
  }
  gotoDetail73(){
    this.router.navigate(['detail73']);
  }
  gotoDetail74(){
    this.router.navigate(['detail74']);
  }
  gotoDetail75(){
    this.router.navigate(['detail75']);
  }
  gotoDetail76(){
    this.router.navigate(['detail76']);
  }
  gotoDetail77(){
    this.router.navigate(['detail77']);
  }
  gotoDetail78(){
    this.router.navigate(['detail78']);
  }
  gotoDetail79(){
    this.router.navigate(['detail79']);
  }
  gotoDetail82(){
    this.router.navigate(['detail82']);
  }
  gotoDetail83(){
    this.router.navigate(['detail83']);
  }
  gotoDetail91(){
    this.router.navigate(['detail91']);
  }
  gotoDetail99(){
    this.router.navigate(['detail99']);
  }
  gotoDetail102(){
    this.router.navigate(['detail102']);
  }
  gotoDetail103(){
    this.router.navigate(['detail103']);
  }
  gotoDetail104(){
    this.router.navigate(['detail104']);
  }
  gotoDetail105(){
    this.router.navigate(['detail105']);
  }
  gotoDetail108(){
    this.router.navigate(['detail108']);
  }
  gotoDetail109(){
    this.router.navigate(['detail109']);
  }
  gotoDetail111(){
    this.router.navigate(['detail111']);
  }
  gotoDetail112(){
    this.router.navigate(['detail112']);
  }
  gotoDetail113(){
    this.router.navigate(['detail113']);
  }
  gotoDetail118(){
    this.router.navigate(['detail118']);
  }
  gotoDetail122(){
    this.router.navigate(['detail122']);
  }
  gotoDetail124(){
    this.router.navigate(['detail124']);
  }
  gotoDetail125(){
    this.router.navigate(['detail125']);
  }
  gotoDetail127(){
    this.router.navigate(['detail127']);
  }
  gotoDetail128(){
    this.router.navigate(['detail128']);
  }
  gotoDetail129(){
    this.router.navigate(['detail129']);
  }
  gotoDetail134(){
    this.router.navigate(['detail134']);
  }
  gotoDetail135(){
    this.router.navigate(['detail135']);
  }
  gotoDetail136(){
    this.router.navigate(['detail136']);
  }
  gotoDetail138(){
    this.router.navigate(['detail138']);
  }
  gotoDetail140(){
    this.router.navigate(['detail140']);
  }
  gotoDetail141(){
    this.router.navigate(['detail141']);
  }
  gotoDetail142(){
    this.router.navigate(['detail142']);
  }
  gotoDetail144(){
    this.router.navigate(['detail144']);
  }
  gotoDetail145(){
    this.router.navigate(['detail145']);
  }
  gotoDetail148(){
    this.router.navigate(['detail148']);
  }
  gotoDetail151(){
    this.router.navigate(['detail151']);
  }
  gotoDetail153(){
    this.router.navigate(['detail153']);
  }
  gotoDetail158(){
    this.router.navigate(['detail158']);
  }
  gotoDetail160(){
    this.router.navigate(['detail160']);
  }
  gotoDetail163(){
    this.router.navigate(['detail163']);
  }
  gotoDetail166(){
    this.router.navigate(['detail166']);
  }
  gotoDetail167(){
    this.router.navigate(['detail167']);
  }
  gotoDetail169(){
    this.router.navigate(['detail169']);
  }
  gotoDetail170(){
    this.router.navigate(['detail170']);
  }
  gotoDetail174(){
    this.router.navigate(['detail174']);
  }
  gotoDetail176(){
    this.router.navigate(['detail176']);
  }
  gotoDetail177(){
    this.router.navigate(['detail177']);
  }
  gotoDetail178(){
    this.router.navigate(['detail178']);
  }
  gotoDetail181(){
    this.router.navigate(['detail181']);
  }
  gotoDetail182(){
    this.router.navigate(['detail182']);
  }
  gotoDetail184(){
    this.router.navigate(['detail184']);
  }
  gotoDetail185(){
    this.router.navigate(['detail185']);
  }
  gotoDetail197(){
    this.router.navigate(['detail197']);
  }
  gotoDetail198(){
    this.router.navigate(['detail198']);
  }
  gotoDetail201(){
    this.router.navigate(['detail201']);
  }
  gotoDetail202(){
    this.router.navigate(['detail202']);
  }
  gotoDetail204(){
    this.router.navigate(['detail204']);
  }
  gotoDetail205(){
    this.router.navigate(['detail205']);
  }
  gotoDetail206(){
    this.router.navigate(['detail206']);
  }
  gotoDetail207(){
    this.router.navigate(['detail207']);
  }
  gotoDetail208(){
    this.router.navigate(['detail208']);
  }
  gotoDetail209(){
    this.router.navigate(['detail209']);
  }
  gotoDetail210(){
    this.router.navigate(['detail210']);
  }
  gotoDetail211(){
    this.router.navigate(['detail211']);
  }
  gotoDetail212(){
    this.router.navigate(['detail212']);
  }
  gotoDetail213(){
    this.router.navigate(['detail213']);
  }
  gotoDetail214(){
    this.router.navigate(['detail214']);
  }
  gotoDetail215(){
    this.router.navigate(['detail215']);
  }
  gotoDetail216(){
    this.router.navigate(['detail216']);
  }
  gotoDetail217(){
    this.router.navigate(['detail217']);
  }
  gotoDetail218(){
    this.router.navigate(['detail218']);
  }
  gotoDetail219(){
    this.router.navigate(['detail219']);
  }
  topFunction() {
    $('body,html').animate({
      scrollTop : 0                       // Scroll to top of body
  }, 500);
}
}



// WEBPACK FOOTER //
// ./src/app/news/new4.component.ts